import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UltUbicacion } from '../../Models/ultima-ubicacion';

@Component({
  selector: 'app-ult-ubicacion',
  templateUrl: './ult-ubicacion.component.html',
  styleUrls: ['./ult-ubicacion.component.css']
})

export class UltUbicacionComponent implements OnInit {

  @Input()
  item: UltUbicacion;
  fechaUbicacion: Date;
  lat: number;
  long: number;
  map: boolean;

  constructor() { }

  ngOnInit(): void {
  }
}
